import LotacaoList from './list';

export default function LotacaoPage() {
  return <LotacaoList />;
}
